import { Link } from '@/i18n/navigation';
import clsx from 'clsx';
import {
  AnchorHTMLAttributes,
  ButtonHTMLAttributes,
  DetailedHTMLProps,
  PropsWithChildren,
} from 'react';
import styles from './Button.module.scss';

export type ButtonOwnProps = {
  color?: 'primary' | 'secondary' | 'neutral' | 'white';
  variant?: 'filled' | 'outlined' | 'flat';
  href?: string;
};

export type ButtonProps = ButtonOwnProps &
  Omit<DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, 'popover'> &
  Omit<DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>, 'popover'>;

export default function Button({
  children,
  color = 'primary',
  variant = 'filled',
  href,
  className,
  style,
  ...props
}: PropsWithChildren<ButtonProps>) {
  if (href) {
    return (
      <Link
        href={href}
        style={style}
        className={clsx(styles.button, styles.link, styles[color], styles[variant], className)}
        {...props}
      >
        {children}
      </Link>
    );
  }

  return (
    <button
      className={clsx(styles.button, styles[color], styles[variant], className)}
      style={style}
      {...props}
    >
      {children}
    </button>
  );
}
